import { FC } from 'react'
import Rating, { RatingComponentProps } from 'react-rating'

import Icon, { Icons } from '../../../components/Icon'
import { themes } from '../../../theme'

import * as SC from './styled'

export type FormFieldStarPickerProps = Omit<
  RatingComponentProps,
  'onChange' | 'className'
> & {
  className?: string
  id?: string
  name: string
  label?: string
  required?: boolean
  disabled?: boolean
  error?: string
  onChange?: (event: { target: { name: string; value?: number } }) => void
  value: number
}

const FormFieldStarPicker: FC<FormFieldStarPickerProps> = ({
  className,
  id,
  name,
  label,
  required,
  error,
  onChange,
  value,
}) => {
  return (
    <SC.Container className={className}>
      <SC.Label htmlFor={id} required={required} error={!!error}>
        {label}
      </SC.Label>
      {}
      {/*@ts-ignore*/}
      <Rating
        initialRating={value}
        emptySymbol={
          <Icon
            icon={Icons.starFull}
            width={45}
            height={45}
            color={themes.theme.colors.greyContour}
          />
        }
        fullSymbol={
          <Icon
            icon={Icons.starFull}
            width={45}
            height={45}
            color={themes.theme.colors.pinkSecondary}
          />
        }
        onChange={(index) => {
          onChange?.({
            target: {
              name: name,
              value: index ?? 0,
            },
          })
        }}
      />
      {error && <SC.ErrorMessage>{error}</SC.ErrorMessage>}
    </SC.Container>
  )
}

export default FormFieldStarPicker
